// filepath: src/components/LanguageSwitcher.jsx
import React from "react";
import { useTranslation } from "react-i18next";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const handleChange = (e) => {
    i18n.changeLanguage(e.target.value); // ✅ Correct way
  };

  return (
    <select
      onChange={handleChange}
      value={i18n.language}
      className="bg-white text-black px-2 py-1 rounded"
    >
      <option value="en">English</option>
      <option value="si">සිංහල</option>
    </select>
  );
};

export default LanguageSwitcher;
